const dayjs = require('dayjs');
const isoWeek = require('dayjs/plugin/isoWeek');
const duration = require('dayjs/plugin/duration');
const localizedFormat = require('dayjs/plugin/localizedFormat');
const updateLocale = require('dayjs/plugin/updateLocale');
const quarterOfYear = require('dayjs/plugin/quarterOfYear');
const utc = require('dayjs/plugin/utc');
const minMax = require('dayjs/plugin/minMax');
const weekday = require('dayjs/plugin/weekday');
const weekOfYear = require('dayjs/plugin/weekOfYear');
const weekYear = require('dayjs/plugin/weekYear');
const dayOfYear = require('dayjs/plugin/dayOfYear');
const advancedFormat = require('dayjs/plugin/advancedFormat');
const customParseFormat = require('dayjs/plugin/customParseFormat');
const localeData = require('dayjs/plugin/localeData');
const timezone = require('dayjs/plugin/timezone');

require('dayjs/locale/sv');
require('dayjs/locale/nb');
require('dayjs/locale/en-gb');

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(updateLocale);
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.extend(isoWeek);
dayjs.extend(weekOfYear);
dayjs.extend(weekday);
dayjs.extend(weekYear);
dayjs.extend(dayOfYear);

dayjs.extend(duration);
dayjs.extend(quarterOfYear);
dayjs.extend(minMax);

dayjs.locale('en-gb');

function addInterval(interval, date) {
  switch (interval) {
    case 'DAILY':
      return date.add(1, 'day');
    case 'WEEKLY':
      return date.add(1, 'week');
    case 'MONTHLY':
      return date.add(1, 'month');
    case 'QUARTERLY':
      return date.add(3, 'month');
    case 'YEARLY':
      return date.add(1, 'year');
    default:
  }

  return date;
}

function getNextDate({ startDate, endDate, from, interval }) {
  // if not started
  if (!startDate || !interval) {
    return null;
  }

  const today = dayjs().startOf('day');
  let nextDate = dayjs(startDate).startOf('day');

  while ((from && !nextDate.isAfter(from)) || nextDate.isBefore(today)) {
    nextDate = addInterval(interval, nextDate);
  }

  // if ends before next delivery
  if (endDate && !nextDate.isBefore(dayjs(endDate).endOf('day'))) {
    return null;
  }

  return nextDate.toDate();
}

function calculateDateRange(dateRange) {
  let { startDate, endDate } = dateRange;

  if (dateRange.predefined === 'LAST_30_DAYS') {
    startDate = dayjs().subtract(29, 'days').startOf('day');
  }

  if (dateRange.predefined === 'LAST_7_DAYS') {
    startDate = dayjs().subtract(6, 'days').startOf('day');
  }

  if (dateRange.predefined === 'ALL_TIME') {
    startDate = null;
    endDate = null;
  }

  return {
    startDate: startDate && dayjs(startDate).utc().format('YYYY-MM-DD HH:mm:ss'),
    endDate: endDate && dayjs(endDate).utc().format('YYYY-MM-DD HH:mm:ss'),
  };
}

module.exports = {
  dayjs,
  getNextDate,
  calculateDateRange,
};
